/* import axios from "axios";
import { useState } from "react";
import { useAuth } from "../../../hooks/useAuth";

export default function Register() {
  const [name, setNmae] = useState("");
  const [lastName, setLastNmae] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const [error, setError] = useState("");

  const handleRegister = async (e) => {
    try {
      const response = await axios.post(
        "/register",
        { name: name, lastName: lastName, email: email, password: password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const userSession = {
        email: response.data.email,
        token: response.data.token,
        role: response.data.role,
        id: response.data.id,
      };

      await login(userSession);
    } catch (error) {
      console.log(error);
      setError("Invalid email or password. Please try again.");
    }
  };
  return();
}
 */
import axios from "axios";
import { useState } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import "./Register.css";

export default function Register() {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { login } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    if (!name || !lastName || !email || !password || !confirmPassword) {
      setError("All fields are required.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      const response = await axios.post(
        "/api/register",
        { name, lastName, email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      const userSession = {
        email: response.data.email,
        token: response.data.token,
        role: response.data.role,
        id: response.data.id,
      };

      await login(userSession);
      navigate("/login");
    } catch (err) {
      console.log(err);
      setError("Registration failed. Please try again.");
    }
  };

  return (
    <div className="register-container">
      <form className="register-form" onSubmit={handleRegister}>
        <h2>Register</h2>

        {error && <p className="error-message">{error}</p>}

        <input
          type="text"
          placeholder="First Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <input
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
        />

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <button type="submit">Register</button>
      </form>
    </div>
  );
}
